// NocturnalPage.js
import React, { useState, useEffect } from 'react';
import './NocturnalPage.css';

const NocturnalPage = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    // Countdown to 31 October 2026, 00:00 SAST
    const target = new Date('2026-10-31T00:00:00+02:00').getTime();

    const tick = () => {
      const now = Date.now();
      const diff = Math.max(0, target - now);

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000),
      });
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="nocturnal-page">
      <div className="bg-gradient" />
      <div className="stars" />

      <div className="content">
        <div className="eyebrow">NOCTURNAL</div>
        
        <div className="countdown">
          <div className="count-block">
            <span className="count-num">{String(timeLeft.days).padStart(2, '0')}</span>
            <span className="count-label">Days</span>
          </div>
          <div className="count-block">
            <span className="count-num">{String(timeLeft.hours).padStart(2, '0')}</span>
            <span className="count-label">Hours</span>
          </div>
          <div className="count-block">
            <span className="count-num">{String(timeLeft.minutes).padStart(2, '0')}</span>
            <span className="count-label">Mins</span>
          </div>
          <div className="count-block">
            <span className="count-num">{String(timeLeft.seconds).padStart(2, '0')}</span>
            <span className="count-label">Secs</span>
          </div>
        </div>

        <div className="date">31 October 2026</div>
      </div>
    </div>
  );
};

export default NocturnalPage;